// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9p-0";
export var optionCard = "_9p-1";